import { OnDestroy, Pipe, PipeTransform } from '@angular/core';
import { map as _map, get as _get, some as _some, get } from 'lodash-es';
import {NS_Enums} from '../../shared/namespaces';
import { formatDateCustom, getBillingCycle, getFromDescription, isJsonValid } from 'src/app/shared/helpers/helpers';
@Pipe({
  name: 'callbackPipe',
  pure: true
})
export class CallbackPipe implements PipeTransform, OnDestroy {

  transform(object: any, name: NS_Enums.callbackNameEnum , callbackInputs: any = {}): any {
    switch (name) {
      case NS_Enums.callbackNameEnum.deletedTablesMessage:
        return Array.from(callbackInputs.deletedTables.keys()).join(', ');
      case NS_Enums.callbackNameEnum.formatDate:
        return formatDateCustom(object);
      case NS_Enums.callbackNameEnum.getBillingCycle:
        return getBillingCycle(object, callbackInputs.passTrueForDayFalseForDaily, callbackInputs.strikeOutPrice);
      case NS_Enums.callbackNameEnum.getFromDescription:
        return getFromDescription(object, callbackInputs.key);
      default:
          break;
    }
  }

  ngOnDestroy(): void {

  }
}
